
import axios, { AxiosPromise, AxiosTransformer } from 'axios';

let ISO_8601 = /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/;
let transformDate = function (data: any) {
    if(data === undefined || data === null)
    {
        return;
    }

    Object.keys(data).forEach(function (k) {
        if(data[k] instanceof Object) {
            transformDate(data[k]);
        } else {
            if (ISO_8601.test(data[k])) {
                data[k] = new Date(Date.parse(data[k]));
            }
        }
    });
    return data;
};
let transformResponse = (axios.defaults.transformResponse as AxiosTransformer[]).concat(transformDate)


import { LoginModel } from './viewmodels/LoginModel'
import { ForgotPasswordModel } from './viewmodels/ForgotPasswordModel'
import { ResetPasswordModel } from './viewmodels/ResetPasswordModel'
import { RegisterMemberModel } from './viewmodels/RegisterMemberModel'
import { JsonReponseModel } from './viewmodels/JsonReponseModel'


        
    // IsLoggedIn
    export function isLoggedIn () : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/isloggedin`, 
            method: "get",
            data: null,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // Login
    export function login (MemberModel: LoginModel) : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/login`, 
            method: "post",
            data: MemberModel,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // Logout
    export function logout () : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/logout`, 
            method: "get",
            data: null,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // PasswordForgotten
    export function passwordForgotten (model: ForgotPasswordModel) : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/passwordforgotten`, 
            method: "post",
            data: model,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // Passwordreset
    export function passwordreset (model: ResetPasswordModel) : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/passwordreset`, 
            method: "post",
            data: model,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // Register
    export function register (model: RegisterMemberModel) : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/register`, 
            method: "post",
            data: model,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // VerifyGuid
    export function verifyGuid (guid: string) : AxiosPromise<JsonReponseModel> {
        return axios({
            url: `api/member/verifyguid?guid=${encodeURIComponent(guid)}`, 
            method: "post",
            data: null,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };    
    // GetCurrentMemberName
    export function getCurrentMemberName () : AxiosPromise<any> {
        return axios({
            url: `api/member/membername`, 
            method: "get",
            data: null,
            transformResponse: transformResponse,
            responseType: "json"
        });
    };
